<div class="container-fluid text-center">
  <div class="top">
    <img src="/assets/images/v001/404.webp" class="top-img">
    <h2 class="fs-1 fw-bolder">{{'404.pageNotFound' | translate}}</h2> 
    <h2>{{'404.pageNotFound2' | translate}}</h2>
  </div>
</div>

<div class="container-fluid px-0 text-center">
  <div class="plug-bg">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-10 offset-sm-1 col-12">
      <div class="search-404">
        <h5 class="fw-bolder">{{'404.searchAlso' | translate}}</h5>
        <form method="post" action="" autocomplete="off">
          <div class="row mt-3">
            <div class="bar">
              <label for="searchSubject" class="visually-hidden">{{'searchpage.subject' | translate}}</label>
              <select class="form-select" id="searchSubject" name="searchSubject" [(ngModel)]="searchSubject">
                <option [ngValue]="undefined">{{'searchpage.allSubject' | translate}}</option>
                <ng-container *ngFor="let opt of SUBJECT_OPTIONS">
                  <option [ngValue]="opt.label">{{opt.label}}</option>
                </ng-container>
              </select>
  
              <div class="searchbar">
                <label for="search_tool_searchKeyword" class="visually-hidden">{{'keyword' | translate}}</label>
                <input id="search_tool_searchKeyword" type="text" placeholder="{{'searchpage.searchPlaceholder2' | translate}}"
                name="searchKeyword" [(ngModel)]="searchKeyword" (ngModelChange)="onKeywordChange($event)"
                (focus)="onFocusSearchKeywordInput()" #searchKeywordInput>
                <tm-auto-complete-options #skACO="tmAutoCompleteOptions"
                [options]="keywordsOptions"
                [togglerEl]="searchKeywordInput"
                id="search_tool_searchKeywordOptions"
                label="{{'keywordAutoCompleteOptions' | translate}}"
                (selected)="searchKeyword = $event; onKeywordChange($event); onClickSearch();"
                ></tm-auto-complete-options>
              </div>
              
              <a href="javascript:void(0)" role="button" title="{{'search' | translate}}" class="searchtool"
              (click)="onClickSearch($event)">
                <i class="fa fa-search" aria-hidden="true"></i>
                <span class="visually-hidden">{{'search' | translate}}</span>
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <a routerLink="{{homePath}}" title="{{'toHome' | translate}}"><img src="/assets/images/v001/404-home.svg" alt="" class="errorimg"></a>
</div>